import { useCallback, useEffect, useState } from "react";

/**
 * useDashboardData
 * Generic data-fetching hook for dashboard endpoints.
 * Handles loading, error, data, and exposes a refetch() helper.
 *
 * @param {string} endpoint - backend endpoint path, e.g. "/visualize/sales"
 * @param {object} options - { method?: 'GET'|'POST', body?: any }
 */
export default function useDashboardData(endpoint, options = {}) {
  const { method = "POST", body } = options;
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const fetcher = useCallback(async () => {
    if (!endpoint) return;
    setLoading(true);
    setError("");
    try {
      const res = await fetch(`https://restaurant-analytics-backend.onrender.com${endpoint}`, {
        method,
        headers:
          body && !(body instanceof FormData)
            ? { "Content-Type": "application/json" }
            : undefined,
        body: body && !(body instanceof FormData) ? JSON.stringify(body) : body,
      });
      const json = await res.json();
      if (!res.ok)
        throw new Error(json?.detail || `Failed to fetch ${endpoint}`);
      setData(json);
    } catch (e) {
      setError(e.message || String(e));
    } finally {
      setLoading(false);
    }
  }, [endpoint, method, body]);

  useEffect(() => {
    fetcher();
  }, [fetcher]);

  return { data, loading, error, refetch: fetcher };
}
